import { trans } from '../../../../app';

export const availableTypes =  () => [
  {
    label: trans('app.education.education'),
    value: 'education',
  },
  {
    label: trans('app.education.instructional_materials'),
    value: 'instructional_materials',
  },
];
